import "./cookieConsent.scss";
import { useState } from "react";

const CookiePreferencesModal = ({ savePreferences }) => {
  // 🔥 THE FIX: Read your existing localStorage settings right as the modal mounts!
  const [preferences, setPreferences] = useState(() => {
    const savedPrefs = localStorage.getItem("cookiePreferences");
    if (savedPrefs) {
      try {
        return JSON.parse(savedPrefs);
      } catch (e) {
        console.error("Failed to parse saved cookie data configurations:", e);
      }
    }

    // Fallback defaults if no choices have been made yet
    return {
      essential: true, // Always required
      analytics: false,
      marketing: false,
      functional: false,
    };
  });

  // Track which sections are open (keep this identical)
  const [openSections, setOpenSections] = useState({
    analytics: false,
    marketing: false,
    functional: false,
  });

  const handleChange = (event) => {
    // Stop the event propagation so clicking the checkbox doesn't trigger the accordion fold toggle
    event.stopPropagation();
    const { name, checked } = event.target;
    setPreferences((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSectionToggle = (section) => {
    setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  const handleSubmit = () => {
    savePreferences(preferences);
  };

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-preferences-modal fuel-fade-in">
        <h3>Customize Your Cookie Preferences</h3>
        <p className="modal-intro">
          We respect your privacy. Choose which supplementary monitoring
          networks you wish to allow below.
        </p>

        <form onSubmit={(e) => e.preventDefault()}>
          {/* ESSENTIAL SECTION */}
          <div className="cookie-section-card cookie-section-card--essential">
            <div className="section-row">
              <label className="custom-checkbox-container">
                <input
                  type="checkbox"
                  name="essential"
                  checked={preferences.essential}
                  disabled
                  onClick={(e) => e.stopPropagation()}
                />
                <span className="checkbox-checkmark"></span>
                <span className="checkbox-label">Essential Cookies</span>
              </label>
              <span className="required-badge">Required</span>
            </div>
            <p className="description">
              Essential cookies are necessary for the basic functioning of our
              website. These cookies ensure that you can navigate the site and
              use its features, such as accessing secure areas, maintaining your
              session, and enabling core functionality. Without these cookies,
              certain parts of our website may not work properly. These cookies
              are necessary for the site to function and cannot be disabled.
            </p>
          </div>

          {/* ANALYTICS SECTION */}
          <div className="cookie-section-card">
            <div
              className="section-row"
              onClick={() => handleSectionToggle("analytics")}
            >
              <label
                className="custom-checkbox-container"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  name="analytics"
                  checked={preferences.analytics}
                  onChange={handleChange}
                />
                <span className="checkbox-checkmark"></span>
                <span className="checkbox-label">Analytics Cookies</span>
              </label>
              <span
                className={`accordion-arrow ${
                  openSections.analytics ? "open" : ""
                }`}
              >
                ▼
              </span>
            </div>
            {openSections.analytics && (
              <p className="description fuel-fade-in">
                Analytics cookies help us understand how our visitors interact
                with the website. They collect information about page views,
                time spent on each page, and other engagement metrics. This data
                is essential for us to improve our website’s performance and
                user experience, allowing us to provide you with more relevant
                content.
              </p>
            )}
          </div>

          {/* MARKETING SECTION */}
          <div className="cookie-section-card">
            <div
              className="section-row"
              onClick={() => handleSectionToggle("marketing")}
            >
              <label
                className="custom-checkbox-container"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  name="marketing"
                  checked={preferences.marketing}
                  onChange={handleChange}
                />
                <span className="checkbox-checkmark"></span>
                <span className="checkbox-label">Marketing Cookies</span>
              </label>
              <span
                className={`accordion-arrow ${
                  openSections.marketing ? "open" : ""
                }`}
              >
                ▼
              </span>
            </div>
            {openSections.marketing && (
              <p className="description fuel-fade-in">
                Marketing cookies are used to deliver advertisements that are
                more relevant to you and your interests. They track your online
                behavior across different websites and help us understand how
                effective our marketing campaigns are. By allowing these
                cookies, you may receive targeted promotional content that
                reflects your preferences.
              </p>
            )}
          </div>

          {/* FUNCTIONAL SECTION */}
          <div className="cookie-section-card">
            <div
              className="section-row"
              onClick={() => handleSectionToggle("functional")}
            >
              <label
                className="custom-checkbox-container"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  name="functional"
                  checked={preferences.functional}
                  onChange={handleChange}
                />
                <span className="checkbox-checkmark"></span>
                <span className="checkbox-label">Functional Cookies</span>
              </label>
              <span
                className={`accordion-arrow ${
                  openSections.functional ? "open" : ""
                }`}
              >
                ▼
              </span>
            </div>
            {openSections.functional && (
              <p className="description fuel-fade-in">
                Functional cookies enable our website to remember your
                preferences and enhance your browsing experience. They allow us
                to personalize features such as language settings, login
                details, and layout preferences based on your interactions. With
                these cookies, you can enjoy a more tailored experience whenever
                you visit our site.
              </p>
            )}
          </div>

          <div className="modal-actions-bar">
            <button
              type="button"
              className="save-preferences-btn"
              onClick={handleSubmit}
            >
              Save Chosen Preferences
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CookiePreferencesModal;
